import { OperationRequestData } from "../../data/operationRequestData";
import { ConfigStore } from "../../store/modules/config";
import { PersonStore } from "../../store/modules/person";
import { ContractsStore } from "../../store/modules/contracts";
import { inject, injectable } from "inversify";
import IAlertService from "../alert/IAlertService";
import { OperationsApi } from "../api/OperationsApi";
import { DiTokens } from "../diTokens";
import IErrorService from "../error/IErrorService";
import { OperationModel } from "../../models/operations/operationModel";
import BaseOperationService from "./BaseOperationService";
import storeAccessor from "../../store/storeAccessor";
import { getModule } from "vuex-module-decorators";
import { BarcodeOperationModel } from "../../models/operations/barcodeOperationModel";

/**Сервис проведения операций */
@injectable()
export default class BarcodeOperationService extends BaseOperationService {
  constructor(
    @inject(DiTokens.AlertService) public alertService: IAlertService,
    @inject(DiTokens.ErrorService) public errorService: IErrorService
  ) {
    super(alertService, errorService);
  }

  /**Стор настроек */
  get configStore(): ConfigStore {
    return getModule(ConfigStore, storeAccessor.store);
  }

  /**Стор счетов */
  get contractsStore(): ContractsStore {
    return getModule(ContractsStore, storeAccessor.store);
  }

  /**Стор пользователей */
  get personStore(): PersonStore {
    return getModule(PersonStore, storeAccessor.store);
  }

  /**
 * Инициализация операции
 * @param initData Данные для инициализации
 * */
  public async init(parsedBarcode: string, barcodeFormat: string | null = null): Promise<BarcodeOperationModel> {
    const operationData = new BarcodeOperationModel(parsedBarcode, barcodeFormat);
    try {   
      await this.configStore.fetchApiState();
      if (!this.configStore.apiData.OperationCodeOfBarcode) {
        throw Error("Операция Barcode не поддерживается")
      }
      operationData.RespondentCode =
        this.configStore.apiData.OperationCodeOfBarcode;
    } catch (e) {
      //await this.alertService.error(e.message);
      await this.errorService.errorHandler(e, false, true, "");
    }
    return operationData;
  }


  /**
   * Обработка execute
   */
  public async execute(model: OperationModel): Promise<OperationModel> {
    try {
      let ord: OperationRequestData = await model.createOperationRequest();
      ord.verificationCode = model.VerifyCode;
      ord.operationId = model.OperationId;
      ord = await OperationsApi.executeOperationSendAsync(ord);
      model.setOperationFromRequest(ord, false);
    } catch (e) {
      //await this.alertService.error(e.message);
      await this.errorService.errorHandler(e, false, true, "");
    }
    return model;
  }
}

